import { render, staticRenderFns } from "./CVSelect.vue?vue&type=template&id=05811a4b&scoped=true&"
import script from "./CVSelect.vue?vue&type=script&lang=js&"
export * from "./CVSelect.vue?vue&type=script&lang=js&"
import style0 from "./CVSelect.vue?vue&type=style&index=0&id=05811a4b&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05811a4b",
  null
  
)

export default component.exports